var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "content" },
    [
      _c("div", { staticClass: "md-layout" }, [
        _c("div", { staticClass: "md-layout-item" }, [
          _c("div", { staticClass: "custom-toolbar" }, [
            _c(
              "div",
              { staticClass: "custom-toolbar-start" },
              [
                _c("filter-container", {
                  class: _vm.$root.isTablet ? "tablet-filter-container" : "",
                  attrs: { filters: _vm.issueFilter, filter: _vm.filter },
                  on: { filter: _vm.handleFilterOrSearch },
                }),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "custom-toolbar-end" },
              [
                _c(
                  "div",
                  [
                    _c(
                      "md-button",
                      {
                        staticClass:
                          "md-primary md-just-icon md-round pull-right header-button",
                        attrs: { title: "Refresh List" },
                        on: { click: _vm.handleRefresh },
                      },
                      [_c("md-icon", [_vm._v("refresh")])],
                      1
                    ),
                  ],
                  1
                ),
                _c("create-issue", {
                  staticClass: "tablet-button-margin",
                  on: { issueCreated: _vm.handleIssueCreated },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]),
      _c("div", { staticClass: "md-layout" }, [
        _c(
          "div",
          {
            staticClass:
              "md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100",
            class: _vm.total < _vm.pagination.perPage ? "margin-space-bot" : "",
          },
          [
            _c(
              "md-card",
              [
                _c(
                  "md-card-header",
                  { staticClass: "md-card-header-icon md-card-header-green" },
                  [
                    _c(
                      "div",
                      { staticClass: "card-icon" },
                      [_c("md-icon", [_vm._v("report_problem")])],
                      1
                    ),
                    _c("h4", { staticClass: "title" }, [_vm._v("Issues")]),
                  ]
                ),
                _c("md-card-content", { staticClass: "body-list" }, [
                  !_vm.isListLoading
                    ? _c(
                        "div",
                        [
                          _c(
                            "md-table",
                            { staticClass: "context-menu-support" },
                            [
                              _c(
                                "md-table-row",
                                [
                                  _vm.isMobileView
                                    ? _c("md-table-head", [_vm._v("Status")])
                                    : _vm._e(),
                                  _c("md-table-head", [_vm._v("Reference")]),
                                  _c("md-table-head", [_vm._v("Title")]),
                                  !_vm.isMobileView
                                    ? _c("md-table-head", [
                                        _vm._v("Related To"),
                                      ])
                                    : _vm._e(),
                                  !_vm.isMobileView
                                    ? _c("md-table-head", [_vm._v("Status")])
                                    : _vm._e(),
                                  !_vm.isMobileView
                                    ? _c(
                                        "md-table-head",
                                        { staticClass: "hide-column" },
                                        [_vm._v("Created By")]
                                      )
                                    : _vm._e(),
                                  !_vm.isMobileView
                                    ? _c(
                                        "md-table-head",
                                        { staticClass: "hide-column" },
                                        [_vm._v("Created Date")]
                                      )
                                    : _vm._e(),
                                  !_vm.isMobileView
                                    ? _c("md-table-head", [
                                        _vm._v("Last Updated By"),
                                      ])
                                    : _vm._e(),
                                  !_vm.isMobileView
                                    ? _c(
                                        "md-table-head",
                                        { staticClass: "hide-column" },
                                        [_vm._v("Last Updated")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._l(_vm.issuesList, function (item) {
                                return _c(
                                  "md-table-row",
                                  {
                                    key: item.issueId,
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.showIssueDetailsSidebar(item)
                                      },
                                    },
                                  },
                                  [
                                    _vm.isMobileView
                                      ? _c(
                                          "md-table-cell",
                                          [
                                            _c("issue-status-button", {
                                              attrs: {
                                                issue: item,
                                                "show-mobile-style": true,
                                              },
                                              on: {
                                                statusUpdated:
                                                  _vm.onChangedIssueStatus,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _c("md-table-cell", [
                                      _vm._v(
                                        "\n                                    " +
                                          _vm._s(item.issueReference) +
                                          "\n                                "
                                      ),
                                    ]),
                                    _c(
                                      "md-table-cell",
                                      { staticClass: "title-container" },
                                      [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(item.title) +
                                            "\n                                "
                                        ),
                                      ]
                                    ),
                                    !_vm.isMobileView
                                      ? _c(
                                          "md-table-cell",
                                          [
                                            _c("issue-routed-entity", {
                                              attrs: { item: item },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    !_vm.isMobileView
                                      ? _c(
                                          "md-table-cell",
                                          { staticClass: "status-container" },
                                          [
                                            _c("issue-status-button", {
                                              attrs: { issue: item },
                                              on: {
                                                statusUpdated:
                                                  _vm.onChangedIssueStatus,
                                              },
                                            }),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    !_vm.isMobileView
                                      ? _c(
                                          "md-table-cell",
                                          { staticClass: "hide-column" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(item.createdByName) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    !_vm.isMobileView
                                      ? _c(
                                          "md-table-cell",
                                          { staticClass: "hide-column" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm._f("dateFormat")(
                                                    item.createdDate,
                                                    _vm.DATE_TYPES.standardDate
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    !_vm.isMobileView
                                      ? _c("md-table-cell", [
                                          _vm._v(
                                            "\n                                    " +
                                              _vm._s(item.lastModifiedByName) +
                                              "\n                                "
                                          ),
                                        ])
                                      : _vm._e(),
                                    !_vm.isMobileView
                                      ? _c(
                                          "md-table-cell",
                                          { staticClass: "hide-column" },
                                          [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm._f("dateFormat")(
                                                    item.lastModifiedDate,
                                                    _vm.DATE_TYPES
                                                      .standardDateTime
                                                  )
                                                ) +
                                                "\n                                "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                )
                              }),
                            ],
                            2
                          ),
                          _vm.issuesList.length == 0 && !_vm.isLoading
                            ? _c("div", [
                                _c("p", { staticClass: "no-result-message" }, [
                                  _vm._v(
                                    "No results matching your search/filter could be found."
                                  ),
                                ]),
                              ])
                            : _vm._e(),
                        ],
                        1
                      )
                    : _c("div", [
                        _c(
                          "div",
                          { staticClass: "stopbar-loader" },
                          [
                            _c("fade-loader", {
                              attrs: { loading: _vm.loading, color: "#333333" },
                            }),
                            _c("span", [_vm._v("LOADING")]),
                          ],
                          1
                        ),
                      ]),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "md-card-actions",
        {
          staticClass: "page-footer",
          attrs: { "md-alignment": "space-between" },
        },
        [
          _c("div", [
            _vm.total === _vm.pagination.perPage
              ? _c("p", { staticClass: "card-category" }, [
                  _vm._v(
                    "\n                Page " +
                      _vm._s(_vm.pagination.currentPage) +
                      " of many\n            "
                  ),
                ])
              : _c("p", { staticClass: "card-category" }, [
                  _vm._v(
                    "Page " +
                      _vm._s(_vm.pagination.currentPage) +
                      " of " +
                      _vm._s(_vm.totalPages)
                  ),
                ]),
          ]),
          _c("pagination", {
            staticClass: "pagination-no-border pagination-success",
            attrs: {
              "per-page": _vm.pagination.perPage,
              total: _vm.total,
              "enable-first-page-link": true,
              "enable-last-page-link": true,
            },
            on: {
              "change-page": function ($event) {
                return _vm.handleChangePage($event, _vm.pagination.perPage)
              },
            },
            model: {
              value: _vm.pagination.currentPage,
              callback: function ($$v) {
                _vm.$set(_vm.pagination, "currentPage", $$v)
              },
              expression: "pagination.currentPage",
            },
          }),
        ],
        1
      ),
      _c(
        "transition",
        { attrs: { name: "slide" } },
        [
          _vm.showIssueDetails
            ? _c("issue-sidebar", {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.toggleIssueDetailsWindow,
                    expression: "toggleIssueDetailsWindow",
                  },
                ],
                attrs: { "issue-id": _vm.issueId, data: _vm.issueDetails },
                on: {
                  changeIssueStatus: _vm.onChangedIssueStatus,
                  showAddNotes: _vm.handleAddIssueNotes,
                  closeModal: _vm.toggleIssueDetailsWindow,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }